<template>
  <div>
    <van-field readonly clickable right-icon="arrow-down" placeholder="请选择" :value="value" @click="popup = true" />
    <van-popup ref="popup" v-model="popup" round position="bottom" :close-on-click-overlay="false">
      <van-datetime-picker
        :value="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        type="year-month"
        title="选择年月"
        @cancel="popup = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import dateTimeMixin from './date-time-mixin'
import pad from 'lodash/padStart'

function padZero(val) {
  return pad(val.toString(), 2, '0')
}

export default {
  name: 'DateTimeMonth',
  mixins: [dateTimeMixin],
  methods: {
    onConfirm(value) {
      let year = value.getFullYear()
      let m = padZero(value.getMonth() + 1)
      this.popup = false
      this.valueYMD = `${year}-${m}`
      this.$emit('input', this.valueYMD)
    }
  }
}
</script>
